export const getCallDateFormat = (selectedDate, selectedTime, wcbCallTimes) => {
  if (!selectedDate || !selectedTime || !wcbCallTimes) return null;
  const datetime = new Date(wcbCallTimes.slots[selectedDate][selectedTime].utc);
  const dateUTC = datetime.getUTCDate();
  const dateUTCMonth = datetime.getUTCMonth()
  const dateUTCYear = datetime.getUTCFullYear()

  const date = dateUTC < 10
    ? `0${dateUTC}`
    : dateUTC;

  const month = dateUTCMonth + 1 < 10
    ? `0${dateUTCMonth+1}` 
    : dateUTCMonth+1;

  const year = dateUTCYear < 10
    ? `0${dateUTCYear}`
    : dateUTCYear;

  return `${year}-${month}-${date}`
};

export const getCallTimeFormat = (selectedDate, selectedTime, wcbCallTimes) => {
  if (!selectedDate || !selectedTime || !wcbCallTimes) return null;
  var datetime = new Date(wcbCallTimes.slots[selectedDate][selectedTime].utc);
  const dateUTCHours = datetime.getUTCHours()
  const dateUTCMinutes = datetime.getUTCMinutes()

  const hours = dateUTCHours < 10
    ? `0${dateUTCHours}`
    : dateUTCHours;

  const minutes = dateUTCMinutes < 10
    ? `0${dateUTCMinutes}`
    : dateUTCMinutes;

  return `${hours}:${minutes}`;
};